import { ModalRouteProps } from 'context/ModalRouter';
import React, { FC } from 'react';
import { useToast } from 'app/hooks/useToast';
import { useG2ReviewTrigger } from 'app/hooks/useG2ReviewTrigger';
import getPreselectedValuesFromParams from 'app/components/timeSavers/assignMultipleTasksModal/utils/getPreselectedValuesFromParams';
import { usePostsContainer } from 'components/posts/context';
import AssignTasksPreselectedPosts from 'app/components/timeSavers/assignMultipleTasksModal/AssignTasksPreselectedPosts';
import AssignTasksWithPostsSelection from 'app/components/timeSavers/assignMultipleTasksModal/AssignTasksWithPostsSelection';

type Props = ModalRouteProps;

const AssignMultipleTasksPage: FC<Props> = (props) => {
  const toast = useToast();
  const postsContainer = usePostsContainer();
  const { triggerG2Review } = useG2ReviewTrigger();

  function onSuccess() {
    toast('Tasks are successfully assigned', 'success');
    props.modalManager.close();
    postsContainer.clearSelectedPosts();
    triggerG2Review();
  }

  const preselectedValues = getPreselectedValuesFromParams(props.modalManager);

  return preselectedValues.posts.length !== 0 ? (
    <AssignTasksPreselectedPosts
      modalManager={props.modalManager}
      onSuccess={onSuccess}
      initialValues={preselectedValues}
    />
  ) : (
    <AssignTasksWithPostsSelection
      modalManager={props.modalManager}
      onSuccess={onSuccess}
    />
  );
};

export default AssignMultipleTasksPage;
